/* eslint-disable */
const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  routeRole: state => state.user.routeRole,
  token: state => state.user.token
}
export default getters;
